import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { getSubjectBySlug, GED_SUBJECTS } from '../data/siteContent';

export default function SubjectPage() {
  const { slug } = useParams();
  const subject = getSubjectBySlug(slug);
  if (!subject) return <Navigate to="/program" replace />;

  const others = GED_SUBJECTS.filter((s) => s.id !== subject.id);

  return (
    <MarketingLayout seoTitle={`${subject.title} GED | Success Bridge Academy`} seoDescription={subject.short}>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">GED Subject</span>
          <div className="mk-subject-hero-title">
            <span className="mk-subject-icon lg" style={{ background: `${subject.color}18`, color: subject.color }}>
              <span className="material-symbols-outlined">{subject.icon}</span>
            </span>
            <h1>{subject.title}</h1>
          </div>
          <p>{subject.short}</p>
          <div className="mk-inline-actions" style={{ marginTop: 20 }}>
            <Link to="/signup" className="mk-btn mk-btn-primary">
              Enroll to study {subject.title}
            </Link>
            <Link to="/program" className="mk-btn mk-btn-secondary">
              All subjects
            </Link>
          </div>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container mk-two-col">
          <div>
            <span className="mk-eyebrow">Learning outcomes</span>
            <h2 className="mk-h2">What you will be able to do</h2>
            <ul className="mk-check-list">
              {subject.outcomes.map((o) => (
                <li key={o}>
                  <span className="material-symbols-outlined">check_circle</span>
                  {o}
                </li>
              ))}
            </ul>
          </div>
          <div className="mk-side-panel">
            <h3>Topic map</h3>
            <ul className="mk-topic-list">
              {subject.topics.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <Link to="/pricing" className="mk-btn mk-btn-gold" style={{ width: '100%', justifyContent: 'center', marginTop: 16 }}>
              Choose a study plan
            </Link>
          </div>
        </div>
      </section>

      <section className="mk-section mk-section-soft">
        <div className="mk-container">
          <div className="mk-section-head">
            <span className="mk-eyebrow">Continue exploring</span>
            <h2 className="mk-h2">Other GED subjects</h2>
          </div>
          <div className="mk-subject-grid">
            {others.map((s) => (
              <Link key={s.id} to={`/program/${s.slug}`} className="mk-subject-card">
                <span className="mk-subject-icon" style={{ background: `${s.color}14`, color: s.color }}>
                  <span className="material-symbols-outlined">{s.icon}</span>
                </span>
                <h3>{s.title}</h3>
                <p>{s.short}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
